const breakpoints = {
  values: {
    xl: 1536,
    lg: 1200,
    md: 900,
    sm: 600,
    xs: 0
  }
};
export {
  breakpoints
};
//# sourceMappingURL=breakpoints.js.map
